import {
  DialogActions,
  DialogContent,
  Modal,
  TextField,
} from "@material-ui/core";
import React, { useContext, useState } from "react";
import {
  ButtonCancel,
  ButtonSave,
  CloseIconStyle,
  DialogHeader,
  DialogStyle,
} from "../../../components/modal/Modal";
import { GlobalContext } from "../../../contexts/GlobalContext";
import { updateUserName } from "../../../repositories/portal_api/Users";
import { notify } from "../../../utils/notify";

const ModalChangeUsername = ({
  open,
  handleClose,
  title,
  handleSave,
  ...props
}) => {
  const { userLogged, setUserLogged } = useContext(GlobalContext);
  const [username, setUsername] = useState("");

  const saveCallback = async () => {
    try {
      if (username.trim() === "") {
        notify("Nome de usuário é obrigatório", true, "error");
        return;
      }

      const listName = username.split(" ");
      const firstName = listName[0];
      let lastName = "";
      if (listName.length > 1) {
        lastName = listName.slice(1).join(" ");
      }

      const response = await updateUserName(
        userLogged.userId,
        firstName,
        lastName
      );

      if (response?.success) {
        setUserLogged({ ...userLogged, firstName, lastName });

        localStorage.setItem("firstNamePanel", firstName);
        localStorage.setItem("lastNamePanel", lastName);

        handleClose();
        notify("Nome de usuário atualizado com sucesso", true, "success");
      } else {
        notify("Erro ao atualizar nome de usuário", true, "error");
      }
    } catch (error) {
      console.error(error);
      notify("Erro ao atualizar nome de usuário", true, "error");
      throw error;
    }
  };

  const handleSaveClick = () => {
    handleSave(saveCallback);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogStyle>
        <DialogHeader id="alert-dialog-title">
          <div className="row">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 20,
              }}
            >
              {title || "Alterar nome de usuário"}
            </div>
            <CloseIconStyle
              style={{ marginRight: "6px" }}
              onClick={() => {
                handleClose();
              }}
            />
          </div>
        </DialogHeader>
        <DialogContent style={{ overflowY: "hidden" }}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            label="Nome de usuário"
            value={username}
            onChange={(e) => {
              setUsername(e.target.value);
            }}
          />
        </DialogContent>
        <DialogActions style={{ paddingTop: 24, paddingBottom: 24 }}>
          <ButtonCancel onClick={handleClose}>Cancelar</ButtonCancel>
          <ButtonSave onClick={handleSaveClick}>Salvar</ButtonSave>
        </DialogActions>
      </DialogStyle>
    </Modal>
  );
};

export default ModalChangeUsername;
